import { styled } from 'styled-components'

const borderRadius = '2em'

export const StyledCarouselContainer = styled.div`
  position: relative;
  width: 80%;
  max-width: 1100px;
  overflow: hidden;
  border-radius: ${borderRadius};
`

export const StyledSlidesContainer = styled.div<{
  $currentIndex:number
  $totalSlides:number
}>`
  display: flex;
  width: inherit;
  transition: transform 0.5s ease-in-out;
  transform: ${({ $currentIndex }) => `translateX(-${$currentIndex * 100}%)`};
`

export const StyledSlide = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: top;
  justify-content: left;
  width: 100%;
  min-height: 100px;
  padding: 1.2em;
  margin: 0 0.5px;
  color: ${({ theme }) => theme.colors.palette.ghostWhite};
  background: ${({ theme }) => theme.colors.palette.lightBlack};
  /* border: 1px solid ${({ theme }) => theme.colors.contrast.clamShell}; */
  border-radius: ${borderRadius};
`

export const StyledButton = styled.button<{
  $absolutePosition:'left'|'right',
}>`
  position: absolute;
  top: 50%;
  ${({ $absolutePosition }) => {
    return ($absolutePosition === 'left')
      ? 'left: 10px;'
      : 'right: 10px;'
  }}
  z-index: 1;
  padding: 10px;
  color: ${({ theme }) => theme.colors.contrast.darkBlack};
  cursor: pointer;
  background: ${({ theme }) => theme.colors.contrast.ghostWhite};
  border: none;
  border-radius: 0.8em;
  transition: 0.5s;
  transform: translateY(-50%);

  &:hover {
    border-radius: 50%;
  }
`

export const StyledIndicators = styled.div`
  position: absolute;
  bottom: 10px;
  left: 45%;
  z-index: 1;  display: flex;
  justify-content: center;
  margin-top: 10px;
`

export const StyledIndicator = styled.div<{
  $isActive:boolean,
}>`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  cursor: pointer;
  background: ${({ theme, $isActive }) =>
    ($isActive)
      ? theme.colors.indicator.active
      : theme.colors.indicator.inactive};
  border-radius: 50%;
`
